/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CashflowDto } from '../../models/cashflow-dto';

export interface GetEstimatedClashflow$Params {
  projectId: string;
  budgetIds?: Array<string>;
}

export function getEstimatedClashflow(http: HttpClient, rootUrl: string, params: GetEstimatedClashflow$Params, context?: HttpContext): Observable<StrictHttpResponse<CashflowDto>> {
  const rb = new RequestBuilder(rootUrl, getEstimatedClashflow.PATH, 'get');
  if (params) {
    rb.query('projectId', params.projectId, {});
    rb.query('budgetIds', params.budgetIds, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CashflowDto>;
    })
  );
}

getEstimatedClashflow.PATH = '/v0/Cashflow/estimated';
